import { Application } from "@hotwired/stimulus"

const application = Application.start()

application.debug = false
window.Stimulus = application

import AlarmIconBadgeController from "./alarm_icon_badge_controller"
import AutoTranslationController from "./auto_translation_controller"
import BootstrapModalController from "./bootstrap_modal_controller"
import ClipboardController from "./clipboard_controller"
import CountdownValueController from "./countdown_value_controller"
import CustomerCreditFrameController from "./customer_credit_frame_controller"
import DiscoveryMatcherFormController from "./discovery_matcher_form_controller"
import EnergyFlowGraphController from "./energy_flow_graph_controller"
import GatewayHealthStatusPollerController from "./gateway_health_status_poller_controller"
import PhotoUploadCompressionController from "./photo_upload_compression_controller"
import ProductModelVersionFormController from "./product_model_version_form_controller"
import CapabilitySettingsController from "./capability_settings_controller"
import RealTimeValueController from "./real_time_value_controller"
import SelectizeSearchController from "./selectize_search_controller"
import ThingSettingsUpdateController from "./thing_settings_update_controller"
import TimelineChartController from "./timeline_chart_controller"

application.register("alarm-icon-badge", AlarmIconBadgeController)
application.register("auto-translation", AutoTranslationController)
application.register("bootstrap-modal", BootstrapModalController)
application.register("capability-settings", CapabilitySettingsController)
application.register("clipboard", ClipboardController)
application.register("countdown-value", CountdownValueController)
application.register("customer-credit-frame", CustomerCreditFrameController)
application.register("discovery-matcher-form", DiscoveryMatcherFormController)
application.register("energy-flow-graph", EnergyFlowGraphController)
application.register("gateway-health-status-poller", GatewayHealthStatusPollerController)
application.register("photo-upload-compression", PhotoUploadCompressionController)
application.register("product-model-version-form", ProductModelVersionFormController)
application.register("real-time-value", RealTimeValueController)
application.register("selectize-search", SelectizeSearchController)
application.register("thing-settings-update", ThingSettingsUpdateController)
application.register("timeline-chart", TimelineChartController)

export { application }
